import { Controller } from "@hotwired/stimulus"

// Client-side status filtering for the merged "My Bookings" grid.
// Pills toggle which cards are visible; no server round-trip.
export default class extends Controller {
  static targets = ["pill", "card", "empty"]

  filter(event) {
    const status = event.currentTarget.dataset.status
    this.activate(event.currentTarget)

    let visible = 0
    this.cardTargets.forEach((card) => {
      const show = status === "all" || card.dataset.status === status
      card.classList.toggle("hidden", !show)
      if (show) visible++
    })

    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("hidden", visible > 0)
    }
  }

  activate(activePill) {
    this.pillTargets.forEach((pill) => {
      const isActive = pill === activePill
      pill.classList.toggle("bg-coral-500", isActive)
      pill.classList.toggle("text-white", isActive)
      pill.classList.toggle("bg-gray-100", !isActive)
      pill.classList.toggle("text-gray-700", !isActive)
      pill.classList.toggle("hover:bg-gray-200", !isActive)

      const badge = pill.querySelector("[data-role='count']")
      if (badge) {
        badge.classList.toggle("bg-white/25", isActive)
        badge.classList.toggle("text-white", isActive)
        badge.classList.toggle("bg-white", !isActive)
        badge.classList.toggle("text-gray-600", !isActive)
      }
    })
  }
}
